// src/pages/PublicSupportPage.jsx

import { useEffect, useState } from "react";
import {
  useParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import API from "../services/api";
import { initiateSupportPayment } from "../services/support";

const PublicSupportPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [asset, setAsset] = useState(null);
  const [loading, setLoading] = useState(true);

  const [email, setEmail] = useState("");
  const [customAmount, setCustomAmount] = useState("");
  const [processing, setProcessing] = useState(false);

  // =========================
  // AMOUNT LOGIC (FIXED)
  // =========================

  const initialAmount = searchParams.get("amount");

  const isCustom = initialAmount === "custom";

  const amount = isCustom
    ? Number(customAmount)
    : Number(initialAmount) || 1000;

  // =========================
  // TRUST SUPPORTERS (UI ONLY)
  // =========================

  const supporters = [
    "emma***@gmail.com",
    "james***@yahoo.com",
    "daniel***@outlook.com",
    "sarah***@gmail.com",
    "michael***@icloud.com",
  ];

  // =========================
  // FETCH ASSET
  // =========================

  useEffect(() => {
    const fetchAsset = async () => {
      try {
        const res = await API.get(`/support-assets/s/${slug}`);
        setAsset(res.data);
      } catch (err) {
        console.error("Fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAsset();
  }, [slug]);

  // =========================
  // PAYMENT HANDLER
  // =========================

  const support = async () => {
    if (!email) {
      alert("Please enter email");
      return;
    }

    if (!amount || Number(amount) <= 0) {
      alert("Enter valid amount");
      return;
    }

    try {
      setProcessing(true);

      const res = await initiateSupportPayment({
        email,
        slug,
        amount: Number(amount),
      });

      const paymentLink =
        res?.data?.link ||
        res?.link ||
        res?.payment_link;

      if (paymentLink) {
        window.location.href = paymentLink;
      } else {
        alert("Payment link not generated");
      }
    } catch (err) {
      console.error(err);
      alert("Payment failed");
    } finally {
      setProcessing(false);
    }
  };

  const goToProfileSettings = () => {
    navigate("/profile/settings");
  };

  // =========================
  // LOADING
  // =========================

  if (loading) {
    return <h2 style={{ textAlign: "center" }}>Loading... ⏳</h2>;
  }

  if (!asset) {
    return (
      <div style={{ textAlign: "center", padding: 40 }}>
        <h2>Content not found</h2>
      </div>
    );
  }

  return (
    <div className="container">
      <h2>Support Creator</h2>

      {/* TRUST BAR */}
      <div
        style={{
          marginTop: 10,
          marginBottom: 20,
          padding: "14px 18px",
          borderRadius: 14,
          background: "#fff",
          border: "2px solid #f1f5f9",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 10,
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        }}
      >
        <div>
          <b>🔒 Payments Secured by Flutterwave</b>
          <div style={{ fontSize: 13, color: "#6b7280" }}>
            Trusted infrastructure powering payouts.
          </div>
        </div>

        <div
          style={{
            background: "#fb923c",
            color: "#fff",
            padding: "8px 14px",
            borderRadius: 999,
            fontWeight: "bold",
            fontSize: 13,
          }}
        >
          VERIFIED PAYMENT SYSTEM
        </div>
      </div>

      {/* LIVE TRUST SIGNAL */}
      <div
        style={{
          marginBottom: 20,
          padding: 16,
          borderRadius: 14,
          background: "#ecfeff",
          border: "1px solid #a5f3fc",
        }}
      >
        <b>💚 Recent Supporters</b>

        <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 8 }}>
          {supporters.map((s, i) => (
            <div
              key={i}
              style={{
                background: "#fff",
                padding: 10,
                borderRadius: 10,
                border: "1px solid #e2e8f0",
                fontSize: 14,
              }}
            >
              ✅ {s} supported this creator
            </div>
          ))}
        </div>
      </div>

      {/* CARD */}
      <div className="card">
        {/* CREATOR */}
        <div
          onClick={goToProfileSettings}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            cursor: "pointer",
          }}
        >
          <img
            src={
              asset.creator?.profile_image ||
              "https://via.placeholder.com/55"
            }
            alt="creator profile"
            style={{
              width: 55,
              height: 55,
              borderRadius: "50%",
              border: "2px solid #22c55e",
              objectFit: "cover",
            }}
          />

          <h4>{asset.creator?.display_name || "Creator"}</h4>
        </div>

        <h2>{asset.title}</h2>
        <p>{asset.description}</p>

        {/* VIDEO */}
        {asset.content_link && (
          <button
            className="button-secondary"
            onClick={() => {
              window.open(asset.content_link, "_blank", "noopener,noreferrer");

              setAsset((prev) => ({
                ...prev,
                clicks: (prev.clicks || 0) + 1,
              }));

              API.post(`/support-assets/click/${slug}`).catch(() => {});
            }}
          >
            ▶ Preview Content
          </button>
        )}

        {/* STATS */}
        <div style={{ marginTop: 15 }}>
          <p>🍚 ₦{asset.total_support || 0}</p>
          <p>👁 {asset.clicks || 0}</p>
          <p>🔥 {asset.support_count || 0} supporters</p>
        </div>

        {/* AMOUNT BUTTONS */}
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 20 }}>
          <button onClick={() => setCustomAmount(1000)}>☕ ₦1,000</button>
          <button onClick={() => setCustomAmount(5000)}>🍔 ₦5,000</button>
          <button onClick={() => setCustomAmount(10000)}>👑 ₦10,000</button>
        </div>

        {/* CUSTOM AMOUNT */}
        {isCustom && (
          <input
            className="input"
            type="number"
            placeholder="Enter custom amount"
            value={customAmount}
            onChange={(e) => setCustomAmount(e.target.value)}
            style={{ marginTop: 15 }}
          />
        )}

        {/* EMAIL */}
        <input
          className="input"
          type="email"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ marginTop: 15 }}
        />

        {/* PAY */}
        <button
          className="button"
          style={{ marginTop: 20, width: "100%" }}
          onClick={support}
          disabled={processing}
        >
          {processing ? "Processing..." : `Support ₦${amount || 0}`}
        </button>
      </div>
    </div>
  );
};

export default PublicSupportPage;